/**
 * Order by `position`, and break a tie by `id` — the SAME rule the backend reads with
 * (`ORDER BY position, id`; uuid byte order == lowercase-hex string order).
 *
 * 🔴 The tiebreak is the point. With `position` alone, two items sharing a number keep
 * whatever order they arrived in, and the server used to send a tie in a different order
 * on different requests: a presented Protokoll re-polls every 5s, so two Abschnitte at
 * 2625 swapped places on every poll and the screen jumped (2026-10-05). The server now
 * breaks ties itself; this keeps the screen deterministic even if a response doesn't.
 */
export function byPositionThenId<T extends { position: number; id: string }>(a: T, b: T): number {
  if (a.position !== b.position) return a.position - b.position;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
